import { Component, HostListener } from '@angular/core';
import { UtilityService } from '@granit/common-library';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private utilityService: UtilityService) { }

  title = 'ClientApp';


  @HostListener('document:click', ['$event'])
  click(event) {

  }

  ngOnInit(): void {    
  }

  ngAfterViewInit() {
    this.relocateRecaptchaIframe();
  }

  relocateRecaptchaIframe() {
    const interval = setInterval(() => {
      const badge = document.getElementsByClassName('grecaptcha-badge')[0].parentNode;
      const wrapper = document.getElementById('recaptcha-landmark-wrapper');

      if (badge && wrapper && !wrapper.contains(badge)) {
        wrapper.appendChild(badge);
        clearInterval(interval);
      }
    }, 300);
  }

}
